import { Link } from "react-router-dom";
import { useSiteSettings, useCategories } from "@/hooks/useApi";

const pageLinks = [
  {
    name: "تتبع الطلب",
    slug: "track-order",
    isRoute: true,
    path: "/track-order",
  },
  { name: "من نحن", slug: "about-us" },
  { name: "الشحن والتوصيل", slug: "shipping-delivery" },
  { name: "الإرجاع والاستبدال", slug: "return-policy" },
  { name: "الأسئلة الشائعة", slug: "faq" },
  { name: "سياسة الخصوصية", slug: "privacy-policy" },
  { name: "شروط الاستخدام", slug: "terms-conditions" },
];

export default function Footer() {
  const { data: settings } = useSiteSettings();
  const { data: apiCategories } = useCategories();

  const socialLinks = settings?.social_links || [
    {
      id: 1,
      platform: "Instagram",
      url: "https://instagram.com",
      icon: "ri-instagram-line",
      is_active: true,
      orders: 1,
    },
    {
      id: 2,
      platform: "Facebook",
      url: "https://facebook.com",
      icon: "ri-facebook-line",
      is_active: true,
      orders: 2,
    },
  ];

  const contact = settings?.contact_info || {
    address: "رام الله، فلسطين",
    phone: "+972 59-XXX-XXXX",
    email: "hello@souad-alhaj.com",
    whatsapp: null,
    working_hours: "الأحد - الخميس: 9:00 - 18:00",
  };

  const paymentMethods = [
    { id: 1, name: "Visa", src: "/Visa.png" },
    { id: 2, name: "Mastercard", src: "/Mastercard.png" },
    { id: 3, name: "Bitpay", src: "/Bitpay.png" },
    { id: 4, name: "Apple Pay", src: "/ApplePay.png" },
    { id: 5, name: "Google Pay", src: "/GooglePay.png" },
  ];

  const categories = Array.isArray(apiCategories)
    ? apiCategories.filter((c) => c.active && !c.parent_id)
    : [];

  return (
    <footer className="bg-cream-200 pt-16 md:pt-24 pb-8">
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img src="/logo.svg" alt="سعاد الحاج" className="h-8 w-auto" />
            </Link>
            <p className="text-sm text-charcoal-500 leading-relaxed mb-6">
              علامة تجارية فاخرة للتجميل والعناية بالبشرة. نختار لكِ الأفضل من
              كل مكان.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks
                .filter((s) => s.is_active)
                .map((sl) => (
                  <a
                    key={sl.id}
                    href={sl.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-charcoal-600 hover:bg-charcoal-900 hover:text-white transition-colors"
                  >
                    <i className={`${sl.icon} text-lg`} />
                  </a>
                ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-charcoal-900 mb-5">تسوقي</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/shop"
                  className="text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors"
                >
                  المتجر
                </Link>
              </li>
              {categories.map((c) => (
                <li key={c.id}>
                  <Link
                    to={`/shop?category=${encodeURIComponent(c.name)}`}
                    className="text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-charcoal-900 mb-5">
              الخدمات
            </h3>
            <ul className="space-y-3">
              {pageLinks.map((p) => (
                <li key={p.slug}>
                  <Link
                    to={
                      p.isRoute
                        ? p.path || `/page/${p.slug}`
                        : `/page/${p.slug}`
                    }
                    className="text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors"
                  >
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-charcoal-900 mb-5">
              تواصلي معنا
            </h3>
            <ul className="space-y-3">
              {contact.address && (
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line text-charcoal-400 mt-0.5" />
                  <span className="text-sm text-charcoal-500">
                    {contact.address}
                  </span>
                </li>
              )}
              {contact.phone && (
                <li className="flex items-center gap-2">
                  <i className="ri-phone-line text-charcoal-400" />
                  <span className="text-sm text-charcoal-500">
                    {contact.phone}
                  </span>
                </li>
              )}
              {contact.email && (
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-charcoal-400" />
                  <span className="text-sm text-charcoal-500">
                    {contact.email}
                  </span>
                </li>
              )}
              {contact.whatsapp && (
                <li className="flex items-center gap-2">
                  <i className="ri-whatsapp-line text-charcoal-400" />
                  <span className="text-sm text-charcoal-500">
                    {contact.whatsapp}
                  </span>
                </li>
              )}
              {contact.working_hours && (
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-charcoal-400" />
                  <span className="text-sm text-charcoal-500">
                    {contact.working_hours}
                  </span>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="border-t border-cream-300 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-charcoal-400">
              © 2026 سعاد الحاج. جميع الحقوق محفوظة.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-charcoal-400">طرق الدفع:</span>
              <div className="flex items-center gap-2">
                {paymentMethods.map((pm) => (
                  <div key={pm.id} className="flex items-center justify-center">
                    <img
                      src={pm.src}
                      alt={pm.name}
                      className="h-6 w-auto object-contain"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
